import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';
import {
  Container,
  Button
} from 'reactstrap';
import classNames from 'classnames';

import { getAdditionalPage, getDetailSection } from '../../actions/productAction';
import { Banner, Content } from '../Assets';
import CardLoading from '../../components/Loading/CardLoading';
import FilterAndSort from '../../components/PageSearchDetails/FilterAndSort';
import { isFromAppBrowser, getCloudImageUrl } from '../../utils/Helpers';
import SneakerLoadingSpinner from '../../components/Sneakers/SneakerLoadingSpinner';
import { ASSET_IMAGE, RESOURCE_URL } from '../../config'

class HotProducts extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      page: 1,
      prevY: 0,
      loading: true,
      hasMore: true
    }
  }

  componentDidMount() {
    const { dataCategory } = this.props;
    this.props.getDetailSection(dataCategory, "editors-pick")
    this.props.getAdditionalPage('editors-choices', { params: { page: this.state.page, availables: true, category: dataCategory }});
    let options = {
      root: null, 
      rootMargin: '0px',
      threshold: 1.0
    };
    const isInfiniteScrolL = !isFromAppBrowser();
    this.setState({ isInfiniteScrolL })
    if(isInfiniteScrolL) {
      // Create an observer instance
      this.observer = new IntersectionObserver(
        this.handleObserver.bind(this), // pass the callback
        options
      );
      this.observer.observe(this.loadingRef);
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    if(prevProps.dataProduct.stillPending && !this.props.dataProduct.stillPending){
      const { pagination } = this.props.dataProduct;
      this.setState({
        hasMore: pagination !== null,
        loading: false
      })
    }
    if(prevProps.dataCategory !== this.props.dataCategory){
      const { dataCategory } = this.props;
      await this.setState({ page: 1, loading: true, hasMore: true, prevY: 0 });
      this.props.getAdditionalPage('editors-choices', { params: { page: this.state.page, availables: true, category: dataCategory }});
    }
  }
  

  _handleNextPageClick = async () => {
    if(!this.state.loading && this.state.hasMore){
      const { dataCategory } = this.props;
      const curPage = this.state.page + 1;
      await this.setState({ page: curPage, loading: true });
      this.props.getAdditionalPage('editors-choices', { params: { page: this.state.page, availables: true, category: dataCategory }});
    }
  }

  handleObserver(entities, observer) {
    const { dataProduct: { pagination, stillPending }, dataCategory } = this.props;
    const y = entities[0].boundingClientRect.y;
    if (pagination !== null) {
      if (this.state.prevY > y) {
        const curPage = this.state.page + 1;
        this.props.getAdditionalPage('editors-choices', { params: { page: curPage, availables: true, category: dataCategory }});
        this.setState({ page: curPage, loading: true });
      }
      this.setState({ prevY: y });
    } else if (pagination === null && this.state.hasMore) {
      if (this.state.page === 1) {
        if (this.state.prevY > y) {
          const curPage = this.state.page + 1;
          this.props.getAdditionalPage('editors-choices', { params: { page: curPage, availables: true, category: dataCategory }});
          this.setState({ page: curPage, loading: true });
        }
        this.setState({ prevY: y });
      } else {
        this.setState({
          loading: false
        })
      }
    }
  }

  render() {
    const { dataSection, dataCategory } = this.props;
    const landscapeImage = dataSection.data &&  dataSection.data.images && dataSection.data.images.length > 0 ? dataSection.data.images.find((i) => i.orientation === "landscape") : null;
    const portraitImage = dataSection.data &&  dataSection.data.images && dataSection.data.images.length > 0 ? dataSection.data.images.find((i) => i.orientation === "portrait") : null;
    const imageBanner = landscapeImage ? landscapeImage.URL : null;
    const mobileBanner = portraitImage ? portraitImage.URL : null;
    const bannerImageURL = dataCategory === "handbags"? `${ASSET_IMAGE}/assets-image/hot-products-luxury-landscape.jpg` : `${ASSET_IMAGE}/assets-image/editors-pick-details.jpg`;
    return (
      <Container fluid className="main-container" id="home-container">
        <div className="d-none d-sm-block">
          <Banner
            src={bannerImageURL}
            alt="hot-products"
          />
        </div>
        <div className="d-block d-sm-none">
          <Banner 
            src={getCloudImageUrl(mobileBanner, 1500, "editors-pick")}
            alt={mobileBanner}
          />
        </div>
        <div className="product-list">
          <Content hotProducts={true} />
          {
            !this.state.isInfiniteScrolL?
              <div className="d-flex justify-content-center">
                <Button
                  block
                  size={"lg"}
                  type="button"
                  onClick={this._handleNextPageClick}
                  className={classNames('button-load-more browse__all',{'d-none': this.state.loading || !this.state.hasMore})}
                >
                  Load More
                </Button>
              </div>
            :null
          }
          <SneakerLoadingSpinner
            isLoading={this.state.loading && this.state.page > 1}
            isHide={!this.state.hasMore}
            wrapperRef={loadingRef => this.loadingRef = loadingRef}
          />
        </div>
        
      </Container>
    )
  }
}

const mapStateToProps = state => ({
  dataSection: state.dataProduct.dataSection,
  dataProduct:state.dataProduct,
  dataCategory: state.dataCategory.selected
})

const mapDispatchToProps = dispatch => ({
  getAdditionalPage: (type, params) => dispatch(getAdditionalPage(type, params)),
  getDetailSection: (category, type) => dispatch(getDetailSection(category, type))
})

export default connect(mapStateToProps, mapDispatchToProps)(HotProducts);
